<h5 class="note text-danger text-wrap fw-bolder" *ngIf="moyenne && moyenne.moyenne > 0"> {{ moyenne.moyenne |
  number:'2.0-2':'fr'}}</h5>
